import { queryClient } from "utils/react-query";
const collection = "job_extensions";
export function invalidateAllJobExtensionQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
